import { TableCell, TableRow } from "@mui/material";
import { BsInbox } from "react-icons/bs";

interface EmptyTableProps {
  /** number of columns to span (defaults to spanning the full table) */
  colSpan?: number;
  title?: string;
  description?: string;
}

export default function EmptyTable({
  colSpan = 100,
  title = "موردی یافت نشد",
  description = "هنوز داده‌ای برای نمایش وجود ندارد",
}: EmptyTableProps) {
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        sx={{
          border: "none",
          textAlign: "center",
          padding: "40px 16px",
        }}
      >
        <div className="empty-table">
          <div className="empty-table-icon">
            <BsInbox />
          </div>
          <div className="empty-table-title">{title}</div>
          <div className="empty-table-desc">{description}</div>
        </div>
      </TableCell>
    </TableRow>
  );
}
